/**
 * @author gll
 * 功能：模版模块
 */
import { Service } from '@/tools'
export class TemplateService<T extends TCommodity.Template> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.Template}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  //设置模板-添加属性
  // /api/commodity/template/v1/addTemplateType
  addTemplateType = <K extends T['ApiAddTemplateType']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddTemplateType', data)

  //设置模板-移除
  // /api/commodity/template/v1/removeTemplateType
  removeTemplateType = <K extends T['ApiRemoveTemplateType']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiRemoveTemplateType', data, '删除成功')

  //设置模板
  // /api/commodity/template/v1/updateTemplateType
  updateTemplateType = <K extends T['ApiUpdateTemplateType']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateTemplateType', data)

  // 根据类目id查找模板列表
  templateTypesByCategoryId = <K extends T['ApiTemplateTypesByCategoryId']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiTemplateTypesByCategoryId', data)

  /**
   * 功能：es商品选择器根据类目id查模板属性
   * /api/commodity/template/v1/selectTemplateAttributes
   */
  selectTemplateAttributes = <K extends T['ApiSelectTemplateAttributes']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectTemplateAttributes', data)

  /**
   * 功能：查看该属性是否被类目模板引用
   * /api/commodity/template/v1/selectCategoryTemplateQuote
   */
  selectCategoryTemplateQuote = <K extends T['ApiSelectCategoryTemplateQuote']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectCategoryTemplateQuote', data)
}
